import { Dropdown } from '@ui/themed';
import { SettingRow } from '../../../components/setting-row';

export function SelectField<T extends string>({
  label,
  description,
  value,
  options,
  onChange,
  learnMoreUrl,
}: {
  label: string;
  description?: string;
  value: T;
  options: { value: T; label: string }[];
  onChange: (value: T) => void;
  learnMoreUrl?: string;
}) {
  return (
    <SettingRow
      label={label}
      description={description}
      learnMoreUrl={learnMoreUrl}
      control={
        <div className="w-48 shrink-0">
          <Dropdown options={options} value={value} onChange={(next) => onChange(next as T)} />
        </div>
      }
    />
  );
}
